module.exports = __webpack_public_path__ + "img/calendario-Kinder.cc4d0715.png";